import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { FarmerHarvestProofRoute } from '@harvest-proof/feature';

const searchSchema = z.object({
  token: z.string().catch(''),
});

export const Route = createFileRoute('/farmer-harvest-proof')({
  validateSearch: (search) => searchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useSearch();
  return <FarmerHarvestProofRoute token={token} />;
}
